<!-- メイン -->
<div class="main">
  <div class="main-content p-m-0">
    <div class="search-screen-col">
      <div class="p-col-12 p-d-flex p-jc-center">
        <div class="page-title-container p-pl-1">
          <!-- タイトル -->
          <div class="page-title">
            <label class="name">連携事例一覧</label>
          </div>
        </div>
      </div>
      <div class="p-flex-sm-nowrap side-left">
        <div class="desktop">
          <div class="p-col-12">
            <form [formGroup]="c261SearchForm" (ngSubmit)="getResultCaseStudyDataList(true)">
              <div class="search-container">
                <div class="input-icon-container">
                  <input title="実施地域（市区町村）" type="text" pInputText placeholder="" formControlName="free_word" autocomplete="off" />
                  <i class="pi pi-search search-icon"></i>
                </div>
                <p-accordion [multiple]="true">
                  <p-accordionTab header="実施地域（市区町村）" [disabled]="
                    isDisabledTab('case_study_implementation_city')
                  " [(selected)]="accordion_case_study_implementation_city">
                    <div class="accrodion-form-list">
                      <div class="btn-check">
                        <span><a href="javascript:void(0);" (click)="
                            checkLargeCategory(
                              'checkAll',
                              getDicList(2016),
                              'case_study_implementation_city'
                            )
                          ">すべて選択</a></span>　|　
                        <span class="p-ml-2"><a href="javascript:void(0);" (click)="
                            checkLargeCategory(
                              'removeAll',
                              getDicList(2016),
                              'case_study_implementation_city'
                            )
                          ">解除</a></span>
                      </div>
                      <div *ngFor="let dicData of getDicList(2016)">
                        <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                          c261SearchForm.controls
                            .case_study_implementation_city
                        " aria-label="{{ dicData.sp_name }}"></p-checkbox>
                      </div>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </form>
          </div>
          <div class="p-col-12 btn-block-search">
            <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
              (click)="getResultCaseStudyDataList(true)"></button>
          </div>
        </div>
        <div class="mobile">
          <div class="p-col-12">
            <form [formGroup]="c261SearchForm" (ngSubmit)="getResultCaseStudyDataList(true)">
              <div class="search-container">
                <div class="input-icon-container">
                  <input title="実施地域（市区町村）" type="text" pInputText placeholder="" formControlName="free_word" autocomplete="off" />
                  <i class="pi pi-search search-icon"></i>
                </div>
                <p-accordion [multiple]="true">
                  <p-accordionTab header="実施地域（市区町村）" [disabled]="
                    isDisabledTab('case_study_implementation_city')
                  " [(selected)]="accordion_case_study_implementation_city">
                    <div class="accrodion-form-list">
                      <div class="btn-check">
                        <span><a href="javascript:void(0);" (click)="
                            checkLargeCategory(
                              'checkAll',
                              getDicList(2016),
                              'case_study_implementation_city'
                            )
                          ">すべて選択</a></span>　|　
                        <span class="p-ml-2"><a href="javascript:void(0);" (click)="
                            checkLargeCategory(
                              'removeAll',
                              getDicList(2016),
                              'case_study_implementation_city'
                            )
                          ">解除</a></span>
                      </div>
                      <div *ngFor="let dicData of getDicList(2016)">
                        <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                          c261SearchForm.controls
                            .case_study_implementation_city
                        " aria-label="{{ dicData.sp_name }}"></p-checkbox>
                      </div>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </form>
          </div>
          <div class="p-col-12 btn-block-search">
            <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
              (click)="getResultCaseStudyDataList(true)"></button>
          </div>
        </div>
      </div>

      <div class="p-col-9 item-search-detail">
        <div class="p-fluid p-formgrid p-grid detail-item">
          <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid">
              <div class="card">
                <p-dataView #dv [value]="resultCaseStudyDataList" [paginator]="true" [rows]="15"
                  [showCurrentPageReport]="true" currentPageReportTemplate="{first}～{last}件表示({totalRecords}件中)"
                  [rowsPerPageOptions]="[15, 75, 150]" emptyMessage="データが存在しません" layout="grid" (onPage)="jumpTop()"
                  [sortField]="sortField" [sortOrder]="sortOrder" aria-label="事例表示件数">
                  <!-- ヘッダー -->
                  <ng-template pTemplate="header">
                    <!-- 検索結果数 -->
                    <div class="p-d-flex p-jc-between result-count-area">
                      <div>
                        <label class="count">
                          {{ resultCaseStudyDataList?.length }}
                        </label>
                        件
                      </div>

                    </div>
                  </ng-template>
                  <ng-template let-resultCaseStudyDataItem pTemplate="gridItem">
                    <div class="p-col-12 p-md-4 p-sm-6">
                      <div class="item-area item" (click)="moveC361(resultCaseStudyDataItem.case_study_id)">
                        <!-- 事例イメージ -->
                        <div class="image">
                          <img [src]="
                              resultCaseStudyDataItem?.icon_image
                            " alt="image" />
                        </div>
                        <div class="collaboration_name text-overflow" [pTooltip]="resultCaseStudyDataItem?.case_study_needs_organization_name 
                            + ' × ' + resultCaseStudyDataItem?.case_study_seeds_organization_name" #tt
                          [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500" tooltipPosition="bottom">
                          {{ resultCaseStudyDataItem?.case_study_seeds_organization_name + ' × ' +
                          resultCaseStudyDataItem?.case_study_needs_organization_name }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-dataView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>